import { makeInternalAPIRequest } from 'lib/http/ApiProvider'
import Response from 'lib/http/Response'

export const uploadTransferAgreement = async ({
	photographerName,
	file,
}: {
	photographerName: string
	file: File | null
}): Promise<Response> => {
	const formData = new FormData()
	formData.append('photographerName', photographerName)
	if (file) {
		formData.append('file', file)
	}

	return makeInternalAPIRequest('post', '/transfer-agreements', formData)
}

export const fetchTransferAgreement = async ({
	page,
	perPage,
	filters,
}: {
	page: number
	perPage: number
	filters?: Record<string, string>
}): Promise<Response> => {
	return makeInternalAPIRequest('get', '/transfer-agreements', {
		limit: perPage,
		offset: Math.abs(page * perPage),
		...(filters ? { filters } : {}),
	})
}

export const fetchTransferAgreementImages = async ({
	transferAgreementId,
	page,
	perPage,
	filters,
}: {
	transferAgreementId: string
	page: number
	perPage: number
	filters?: Record<string, string>
}): Promise<Response> => {
	return makeInternalAPIRequest(
		'get',
		`/transfer-agreements/${transferAgreementId}/images`,
		{
			limit: perPage,
			offset: Math.abs(page * perPage),
			...(filters ? { filters } : {}),
		},
	)
}

export const uploadTransferAgreementImages = async ({
	partnerImageIds,
	transferAgreementId,
}: {
	partnerImageIds: string[]
	transferAgreementId: string
}): Promise<Response> => {
	return makeInternalAPIRequest(
		'post',
		`/transfer-agreements/${transferAgreementId}/images`,
		{ partnerImageIds },
	)
}

export const deleteManuallyUploadedImage = async ({
	transferAgreementImageId,
	transferAgreementId,
}: {
	transferAgreementImageId: string
	transferAgreementId: string
}): Promise<Response> => {
	return makeInternalAPIRequest(
		'delete',
		`/transfer-agreements/${transferAgreementId}/images/${transferAgreementImageId}`,
	)
}

export const getTransferAgreementFileLink = async ({
	transferAgreementId,
}: {
	transferAgreementId: string
}): Promise<Response> => {
	return makeInternalAPIRequest(
		'get',
		`/transfer-agreements/${transferAgreementId}/file`,
	)
}

export const deleteTransferAgreement = async ({
	transferAgreementId,
}: {
	transferAgreementId: string
}): Promise<Response> => {
	return makeInternalAPIRequest(
		'delete',
		`/transfer-agreements/${transferAgreementId}`,
	)
}
